import axios, { AxiosInstance } from "axios";
import { getBackendUrl } from "../../shared/static/constants.static";


class BaseApi { 
    public apliClient: AxiosInstance;

    constructor() {
        this.apliClient = axios.create({
            baseURL: getBackendUrl(),
            headers: {
                'Content-Type': 'application/json',
            }
        });
    }
}

export default BaseApi;